export default {
  id: 'pi_1DcrKX2eZvKYlo2CDZorT1JF',
  object: 'payment_intent',
  amount: 1400,
  amount_capturable: 0,
  amount_received: 0,
  application: null,
  application_fee_amount: null,
  canceled_at: null,
  cancellation_reason: null,
  capture_method: 'automatic',
  charges: {
    object: 'list',
    data: [],
    has_more: false,
    url: '/v1/charges?payment_intent=pi_1DcrKX2eZvKYlo2CDZorT1JF',
  },
  client_secret: 'pi_1DcrKX2eZvKYlo2CDZorT1JF_secret_W65yWDMg46CWw7v4XMExcI1OC',
  confirmation_method: 'automatic',
  created: 1543743217,
  currency: 'eur',
  customer: null,
  description: null,
  invoice: null,
  last_payment_error: null,
  livemode: false,
  metadata: {
    "'user_id'": '25',
    order_id: '6735',
  },
  next_action: null,
  on_behalf_of: null,
  payment_method: null,
  payment_method_options: {},
  payment_method_types: ['card'],
  receipt_email: null,
  review: null,
  setup_future_usage: null,
  shipping: null,
  statement_descriptor: null,
  statement_descriptor_suffix: null,
  status: 'requires_payment_method',
  transfer_data: null,
  transfer_group: null,
};
